import { APP_ROUTES } from '@/constants';
import PaymentSystemsPage from '@/views/payment-systems/payment-systems-page.vue';

export const paymentSystemsRoutes = {
  path: APP_ROUTES.PAYMENT_SYSTEMS.PATH,
  name: APP_ROUTES.PAYMENT_SYSTEMS.NAME,
  component: PaymentSystemsPage,
};
